export default __webpack_public_path__ + "static/media/promotionOne.e81471fe.jpg";